import { Falsey } from "lodash";

export function slugify(text: string): string {
  return text
    .toString()
    .toLowerCase()
    .trim()
    .replace(/\s+/g, "-")
    .replace(/[^\w-]+/g, "")
    .replace(/--+/g, "-");
}

export function searchStringContains(
  text: string | null | undefined,
  searchTerm: string,
  startsWith: boolean = false
): boolean {
  if (!text) return false;
  const src = slugify(text);
  const target = slugify(searchTerm.trim());

  return startsWith ? src.startsWith(target) : src.includes(target);
}

export function clsx(...params: (string | Falsey)[]){
  return params?.map(p=>!!p && !!String(p).trim() && String(p).trim()).join(' ')
}